import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({

  customButtonWrapper: {
    width: 'auto'
  },

  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '-2px',
    paddingLeft: '10px',
    paddingRight: '16px',
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0',
      marginTop: '8px',
      flexDirection: 'column',
      width: '100%'
    }
  },

  buttonWrapper: {
    width: 'auto',
    display: 'flex',
    padding: '8px 16px 8px 12px',
    gap: '8px'
  },

  buttonOutlined: {
    backgroundColor: 'transparent',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main
  },

  filterContainer: {
    '& .containerButtons': {
      display: 'flex',
      gap: '20px',
      marginBottom: '20px'
    }
  },

  noDataContainer: {
    '& p': {
      color: theme.app.colors.text.primary,
      fontSize: theme.app.typography.body.fontSize,
      marginBottom: '20px'
    }
  }
}))
